import { render, staticRenderFns } from "./lfDetails.vue?vue&type=template&id=dc67593e&scoped=true&"
import script from "./lfDetails.vue?vue&type=script&lang=js&"
export * from "./lfDetails.vue?vue&type=script&lang=js&"
import style0 from "./lfDetails.vue?vue&type=style&index=0&id=dc67593e&lang=scss&scoped=true&"
import style1 from "./lfDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc67593e",
  null
  
)

export default component.exports